// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*************** Twofa Process bar css ***********/
.signup-step-header-wrap {
    width: 598px;
    height: 105px;
    border: 2px solid #F8F8F8;
    border-radius: 17px;
    margin: 0 auto;
    padding: 0px 60px;
    margin-top: 53px;
}
  
.twofa-progress-bar {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    position: relative;
    margin-top: 15px;
    padding-top: 34px;
}

  .step {
    text-align: center;
    position: relative;
    width: 25%;
  }
  
  .step p {
    margin-bottom: 10px;
    font-size: 14px;
    color: #A7A7A7;
    position: absolute;
    top: -24px;
    font-weight: 500;
    width: 100%;
}
.step:first-child .dot {
    margin: 0;
}

.step:last-child p {
    text-align: right;
}

.step:first-child p {
    text-align: left;
}
.step:last-child .dot {
    margin: auto;
    margin-right: 0;
}
  .step .dot {
    width: 20px;
    height: 20px;
    background-color: #F3F3F3;
    border-radius: 50%;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    cursor: pointer;
  }
  
  .step.active .dot {
    border: 4px solid #00A19B;
    background-color: #fff;
  }
  
  .step.active p {
    color: #1A1919;
  }
  
  .twofa-progress-bar::before {
    content: '';
    position: absolute;
    top: 43px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #A7A7A7;
    opacity: 0.5;
    z-index: 0;
    right: 0px;
    margin: 0 auto;
}

/********** Enable Twofa Guide css ***/
.profile-twofa-main-wrapper{
    width:  598px;
    position: relative;
    margin: 0 auto;
}

.profile-twofa-main-wrap{
    width: 430px;
    margin: 0 auto;
    margin-left: 130px;
}


.twofa-head-main-wrap {
    display: flex;
    align-items: center;
    gap: 26px;
    margin-top: 30px;
}

.twofa-head-main-wrap img {
    width: 49px;
    height: 49px;
    cursor: pointer;
    position: absolute;
    left: 60px;
}

.twofa-head-main-wrap h3 {
    font-size: 30px;
    color: #1A1919;
    font-weight: 700;
    margin: 0px;
}

.authenticator-main-wrapper{
    text-align: center;
}

.authenticator-image-wrap {
    margin-top: 45px;
    margin-bottom: 45px;
}

.authenticator-image-wrap img {
    width: 181px;
    height: 181px;
}

.authenticator-store-wrap p {
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
    margin: 0px;
}

.authenticator-store-icons-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    margin-top: 8px;
}

.authenticator-store-icons-wrap img {
    width: 56px;
    height: 56px;
}

.twofa-footer-wrapper {
    width: 405px;
    position: fixed;
    right: 0;
    left: 70px;
    bottom: 0px;
    padding-bottom: 62px;
    background-color: #fff;
    margin: 0 auto;
    text-align: left;
    /* margin-top: 80px; */
}

.twofa-inner-wrapper {
    height: calc(100vh - 480px);
    overflow: auto;
}

.twofa-footer-wrap p {
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
    margin: 0px;
    padding-bottom: 12px;
}

.twofa-footer-wrap button{
    height: 49px;
    font-size: 14px;
}

.scaner-image-wrap {
    width: 179px;
    height: 181px;
    margin: 0 auto;
    padding: 10px;
    background: #f8f8f8;
    border-radius: 8px;
    margin-top: 50px;
    margin-bottom: 50px;
}

.scaner-image-wrap img{
    width: 100%;
}

.secert-key-wrap {
    position: relative;
    width: 100%;
    height: 62px;
    background: #F3F3F3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 34px;
    border-radius: 9px;
}

.secert-key-wrap img{
    width: 23px;
    height: 23px;
    cursor: pointer;
}

.secert-key-wrap p {
    width: 260px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 500;
    margin: 0px;
    color: #1A1919;
}


.twfa-scan-text p {
    font-size: 14px;
    color: #1A1919;
    margin: 0px;
    padding-top: 10px;
}

/******* Two 6 Digit Code ***/

.authentication-code-main-wrap {
    margin-top: 146px;
    text-align: center
}

.pin-code.password-otp-input {
    justify-content: flex-start;
  }

  .pin-code {
    padding: 0;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  
  .pin-code.password-otp-input input{
      text-align: center;
      width: 62px;
      height: 62px;
      font-size: 14px;
      color: #1A1919;
      font-weight: 600;
      border: 1px solid #F3F3F3;
      border-radius: 9px;
      outline: none;
      margin-right: 10px;
      padding: 0px;
  }

  .enable-pin-code-input.pin-code.password-otp-input input{
    width: 70px;
    height: 70px;
    font-size: 16px;
    margin-top: 20px;
}

  .authentication-code-main-wrap p {
    font-size: 18px;
    color: #1A1919;
    font-weight: 700;
    margin: 0px;
    margin-bottom: 26px;
}


.twofa-checkbox-container .checkmark {
    height: 29px;
    width: 29px;
}

.twofa-checkbox-container .checkmark:after {
    left: 11px;
    top: 6px;
    width: 7px;
    height: 14px;
}

.twofa-scan-term-checkbox {
    display: flex;
    gap: 42px;
    margin-bottom: 0px;
}

.twofa-scan-term-checkbox p{
    margin-top: -4px;
}

.twofa-head-main-wrap img:hover{
    transform: scale(0.9);
}


.checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkbox-container .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 30px;
    width: 30px;
    background-color: #f3f3f3;
    border-radius: 0px;
    border: none;
}


/******* Resposive css ****/
@media (max-width: 768px) {
    .signup-step-header-wrap {
        width: 100%;
        height: 80px;
        margin-top: 28px;
        padding: 0px 27px;
    }

    .profile-twofa-main-wrapper {
        width: 100%;
        padding: 0px 20px;
    }

    .twofa-progress-bar {
        margin-top: 8px;
    }

    .step p {
        font-size: 10px;
        top: -20px;
        white-space: nowrap;
    }

    .step .dot {
        width: 14px;
        height: 14px;
    }

    .twofa-progress-bar::before {
        top: 40px;
    }

    .twofa-head-main-wrap {
        display: flex;
        align-items: center;
        gap: 18px;
        margin-top: 20px;
    }

    .twofa-head-main-wrap img {
        width: 33px;
        height: 33px;
        position: unset;
    }

    .twofa-head-main-wrap h3 {
        font-size: 18px;
    }

    .authenticator-image-wrap img {
        width: 162px;
        height: 162px;
    }

    .authenticator-image-wrap {
        margin-top: 18px;
        margin-bottom: 18px;
    }

    .profile-twofa-main-wrap {
        width: 100%;
        margin-left: 0px;
        /* padding-bottom: 70px; */
    }

    .twofa-footer-wrap p {
        font-size: 12px;
    }

    .twofa-footer-wrapper {
        width: 100%;
        position: unset;
        left: 0;
        bottom: 80px;
        right: 0;
        padding: 30px 20px;
        padding-top: 40px;
    }

    .authenticator-store-wrap p {
        font-size: 14px;
    }

    .authenticator-store-icons-wrap img {
        width: 46px;
        height: 46px;
    }

    .twofa-inner-wrapper {
        height: unset;
        /* height: calc(100vh - 540px); */
    }

    .twfa-scan-text p {
        font-size: 14px;
        padding-top: 10px;
        margin-left: 50px;
    }

    .scaner-image-wrap {
        width: 120px;
        height: 120px;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .secert-key-wrap {
        height: 62px;
        padding: 0px 30px;
    }

    .secert-key-wrap img {
        width: 18px;
        height: 18px;
    }

    .twofa-checkbox-container .checkmark {
        height: 25px;
        width: 25px;
    }

    .twofa-checkbox-container .checkmark:after {
        left: 10px;
        top: 5px;
        width: 6px;
        height: 12px;
    }

    .twofa-scan-term-checkbox {
        gap: 38px;
    }

    .authentication-code-main-wrap {
        margin-top: 80px;
        margin-bottom: 80px;
        text-align: center;
    }

    .pin-code.password-otp-input input {
        width: 100%;
        height: 50px;
        margin-right: 6px !important;
        font-size: 12px;
    }

    .enable-pin-code-input.pin-code.password-otp-input input{
        width: 58px;
        height: 58px;
        margin-top: 0px;
    }

    .authentication-code-main-wrap p {
        font-size: 14px;
        margin-bottom: 20px;
    }

    .twofa-footer-wrap button {
        height: 62px;
        font-size: 14px;
    }

}


@media (max-width: 360px) {
 
}

@media (min-width: 768px) and (max-width: 1024px) {
    .signup-step-header-wrap {
        width: 532px;
        height: 82px;
        margin-top: 20px;
    }

    .twofa-progress-bar {
        margin-top: 8px;
    }

    .step p {
        font-size: 12px;
        top: -20px;
    }

    .step .dot {
        width: 14px;
        height: 14px;
    }

    .twofa-progress-bar::before {
        top: 40px;
    }

    .twofa-head-main-wrap img {
        width: 33px;
        height: 33px;
    }

    .twofa-head-main-wrap h3 {
        font-size: 18px;
    }

    .authenticator-image-wrap img {
        width: 135px;
        height: 135px;
    }

    .authenticator-image-wrap {
        margin-top: 26px;
        margin-bottom: 26px;
    }

    .profile-twofa-main-wrap {
        width: 348px;
        margin-left: 120px;
    }

    .profile-twofa-main-wrapper {
        width: 532px;
    }

    .twofa-footer-wrap p {
        font-size: 12px;
    }

    .twofa-footer-wrapper {
        width: 348px;
        position: unset;
        padding-bottom: 100px;
    }

    .authenticator-store-wrap p {
        font-size: 12px;
    }

    .authenticator-store-icons-wrap img {
        width: 47px;
        height: 47px;
    }

    .twofa-inner-wrapper {
        height: calc(100vh - 300px);
    }

    .twfa-scan-text p {
        font-size: 12px;
        padding-top: 8px;
    }

    .scaner-image-wrap {
        width: 119px;
        height: 120px;
        margin-top: 26px;
        margin-bottom: 34px;
    }

    .secert-key-wrap {
        height: 48px;
        padding: 0px 30px;
    }

    .secert-key-wrap img {
        width: 18px;
        height: 18px;
    }

    .twofa-checkbox-container .checkmark {
        height: 25px;
        width: 25px;
    }

    .twofa-checkbox-container .checkmark:after {
        left: 10px;
        top: 5px;
        width: 6px;
        height: 12px;
    }

    .twofa-scan-term-checkbox {
        gap: 38px;
    }

    .authentication-code-main-wrap {
        margin-top: 104px;
        text-align: center;
    }

    .pin-code.password-otp-input input {
        width: 50px;
        height: 50px;
        margin-right: 9px;
        font-size: 12px;
    }

    .enable-pin-code-input.pin-code.password-otp-input input{
        width: 58px;
        height: 58px;
        margin-top: 0px;
    }

    .authentication-code-main-wrap p {
        font-size: 14px;
        margin-bottom: 20px;
    }
}


@media (min-width: 1025px) and (max-width: 1599px) {
    .signup-step-header-wrap {
        width: 532px;
        height: 82px;
        margin-top: 20px;
    }

    .twofa-progress-bar {
        margin-top: 8px;
    }

    .step p {
        font-size: 12px;
        top: -20px;
    }

    .step .dot {
        width: 14px;
        height: 14px;
    }

    .twofa-progress-bar::before {
        top: 40px;
    }

    .twofa-head-main-wrap img {
        width: 33px;
        height: 33px;
    }

    .twofa-head-main-wrap h3 {
        font-size: 18px;
    }

    .authenticator-image-wrap img {
        width: 135px;
        height: 135px;
    }

    .authenticator-image-wrap {
        margin-top: 26px;
        margin-bottom: 26px;
    }

    .profile-twofa-main-wrap {
        width: 348px;
        margin-left: 120px;
    }

    .profile-twofa-main-wrapper {
        width: 532px;
    }

    .twofa-footer-wrap p {
        font-size: 12px;
    }

    .twofa-footer-wrapper {
        width: 348px;
        padding-bottom: 30px;
        left: 60px;
    }

    .authenticator-store-wrap p {
        font-size: 12px;
    }

    .authenticator-store-icons-wrap img {
        width: 47px;
        height: 47px;
    }

    .twofa-inner-wrapper {
        height: calc(100vh - 300px);
    }

    .twfa-scan-text p {
        font-size: 12px;
        padding-top: 8px;
    }

    .scaner-image-wrap {
        width: 119px;
        height: 120px;
        margin-top: 26px;
        margin-bottom: 34px;
    }

    .secert-key-wrap {
        height: 48px;
        padding: 0px 30px;
    }

    .secert-key-wrap img {
        width: 18px;
        height: 18px;
    }

    .twofa-checkbox-container .checkmark {
        height: 25px;
        width: 25px;
    }

    .twofa-checkbox-container .checkmark:after {
        left: 10px;
        top: 5px;
        width: 6px;
        height: 12px;
    }

    .twofa-scan-term-checkbox {
        gap: 38px;
    }

    .authentication-code-main-wrap {
        margin-top: 104px;
        text-align: center;
    }

    .pin-code.password-otp-input input {
        width: 50px;
        height: 50px;
        margin-right: 9px;
        font-size: 12px;
    }

    .enable-pin-code-input.pin-code.password-otp-input input{
        width: 58px;
        height: 58px;
        margin-top: 0px;
    }

    .authentication-code-main-wrap p {
        font-size: 14px;
        margin-bottom: 20px;
    }

}`, "",{"version":3,"sources":["webpack://./src/Components/twofa/twofa.css"],"names":[],"mappings":";AACA,kDAAkD;AAClD;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;EAEE;IACE,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;EACE;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,cAAc;AAClB;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA,6BAA6B;;AAE7B;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,cAAc;IACd,aAAa;IACb,uBAAuB;EACzB;;EAEA;MACI,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,eAAe;MACf,cAAc;MACd,gBAAgB;MAChB,yBAAyB;MACzB,kBAAkB;MAClB,aAAa;MACb,kBAAkB;MAClB,YAAY;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;EAEE;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;;AAGA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA,2BAA2B;AAC3B;IACI;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,OAAO;QACP,YAAY;QACZ,QAAQ;QACR,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,iCAAiC;IACrC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,UAAU;QACV,QAAQ;QACR,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;AAEJ;;;AAGA;;AAEA;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,UAAU;QACV,QAAQ;QACR,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;;AAGA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,oBAAoB;QACpB,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,UAAU;QACV,QAAQ;QACR,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;AAEJ","sourcesContent":["\r\n/*************** Twofa Process bar css ***********/\r\n.signup-step-header-wrap {\r\n    width: 598px;\r\n    height: 105px;\r\n    border: 2px solid #F8F8F8;\r\n    border-radius: 17px;\r\n    margin: 0 auto;\r\n    padding: 0px 60px;\r\n    margin-top: 53px;\r\n}\r\n  \r\n.twofa-progress-bar {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    position: relative;\r\n    margin-top: 15px;\r\n    padding-top: 34px;\r\n}\r\n\r\n  .step {\r\n    text-align: center;\r\n    position: relative;\r\n    width: 25%;\r\n  }\r\n  \r\n  .step p {\r\n    margin-bottom: 10px;\r\n    font-size: 14px;\r\n    color: #A7A7A7;\r\n    position: absolute;\r\n    top: -24px;\r\n    font-weight: 500;\r\n    width: 100%;\r\n}\r\n.step:first-child .dot {\r\n    margin: 0;\r\n}\r\n\r\n.step:last-child p {\r\n    text-align: right;\r\n}\r\n\r\n.step:first-child p {\r\n    text-align: left;\r\n}\r\n.step:last-child .dot {\r\n    margin: auto;\r\n    margin-right: 0;\r\n}\r\n  .step .dot {\r\n    width: 20px;\r\n    height: 20px;\r\n    background-color: #F3F3F3;\r\n    border-radius: 50%;\r\n    margin: 0 auto;\r\n    position: relative;\r\n    z-index: 1;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .step.active .dot {\r\n    border: 4px solid #00A19B;\r\n    background-color: #fff;\r\n  }\r\n  \r\n  .step.active p {\r\n    color: #1A1919;\r\n  }\r\n  \r\n  .twofa-progress-bar::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 43px;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 2px;\r\n    background-color: #A7A7A7;\r\n    opacity: 0.5;\r\n    z-index: 0;\r\n    right: 0px;\r\n    margin: 0 auto;\r\n}\r\n\r\n/********** Enable Twofa Guide css ***/\r\n.profile-twofa-main-wrapper{\r\n    width:  598px;\r\n    position: relative;\r\n    margin: 0 auto;\r\n}\r\n\r\n.profile-twofa-main-wrap{\r\n    width: 430px;\r\n    margin: 0 auto;\r\n    margin-left: 130px;\r\n}\r\n\r\n\r\n.twofa-head-main-wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 26px;\r\n    margin-top: 30px;\r\n}\r\n\r\n.twofa-head-main-wrap img {\r\n    width: 49px;\r\n    height: 49px;\r\n    cursor: pointer;\r\n    position: absolute;\r\n    left: 60px;\r\n}\r\n\r\n.twofa-head-main-wrap h3 {\r\n    font-size: 30px;\r\n    color: #1A1919;\r\n    font-weight: 700;\r\n    margin: 0px;\r\n}\r\n\r\n.authenticator-main-wrapper{\r\n    text-align: center;\r\n}\r\n\r\n.authenticator-image-wrap {\r\n    margin-top: 45px;\r\n    margin-bottom: 45px;\r\n}\r\n\r\n.authenticator-image-wrap img {\r\n    width: 181px;\r\n    height: 181px;\r\n}\r\n\r\n.authenticator-store-wrap p {\r\n    font-size: 14px;\r\n    color: #1A1919;\r\n    font-weight: 400;\r\n    margin: 0px;\r\n}\r\n\r\n.authenticator-store-icons-wrap{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 14px;\r\n    margin-top: 8px;\r\n}\r\n\r\n.authenticator-store-icons-wrap img {\r\n    width: 56px;\r\n    height: 56px;\r\n}\r\n\r\n.twofa-footer-wrapper {\r\n    width: 405px;\r\n    position: fixed;\r\n    right: 0;\r\n    left: 70px;\r\n    bottom: 0px;\r\n    padding-bottom: 62px;\r\n    background-color: #fff;\r\n    margin: 0 auto;\r\n    text-align: left;\r\n    /* margin-top: 80px; */\r\n}\r\n\r\n.twofa-inner-wrapper {\r\n    height: calc(100vh - 480px);\r\n    overflow: auto;\r\n}\r\n\r\n.twofa-footer-wrap p {\r\n    font-size: 14px;\r\n    color: #1A1919;\r\n    font-weight: 400;\r\n    margin: 0px;\r\n    padding-bottom: 12px;\r\n}\r\n\r\n.twofa-footer-wrap button{\r\n    height: 49px;\r\n    font-size: 14px;\r\n}\r\n\r\n.scaner-image-wrap {\r\n    width: 179px;\r\n    height: 181px;\r\n    margin: 0 auto;\r\n    padding: 10px;\r\n    background: #f8f8f8;\r\n    border-radius: 8px;\r\n    margin-top: 50px;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.scaner-image-wrap img{\r\n    width: 100%;\r\n}\r\n\r\n.secert-key-wrap {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 62px;\r\n    background: #F3F3F3;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0px 34px;\r\n    border-radius: 9px;\r\n}\r\n\r\n.secert-key-wrap img{\r\n    width: 23px;\r\n    height: 23px;\r\n    cursor: pointer;\r\n}\r\n\r\n.secert-key-wrap p {\r\n    width: 260px;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    margin: 0px;\r\n    color: #1A1919;\r\n}\r\n\r\n\r\n.twfa-scan-text p {\r\n    font-size: 14px;\r\n    color: #1A1919;\r\n    margin: 0px;\r\n    padding-top: 10px;\r\n}\r\n\r\n/******* Two 6 Digit Code ***/\r\n\r\n.authentication-code-main-wrap {\r\n    margin-top: 146px;\r\n    text-align: center\r\n}\r\n\r\n.pin-code.password-otp-input {\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .pin-code {\r\n    padding: 0;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .pin-code.password-otp-input input{\r\n      text-align: center;\r\n      width: 62px;\r\n      height: 62px;\r\n      font-size: 14px;\r\n      color: #1A1919;\r\n      font-weight: 600;\r\n      border: 1px solid #F3F3F3;\r\n      border-radius: 9px;\r\n      outline: none;\r\n      margin-right: 10px;\r\n      padding: 0px;\r\n  }\r\n\r\n  .enable-pin-code-input.pin-code.password-otp-input input{\r\n    width: 70px;\r\n    height: 70px;\r\n    font-size: 16px;\r\n    margin-top: 20px;\r\n}\r\n\r\n  .authentication-code-main-wrap p {\r\n    font-size: 18px;\r\n    color: #1A1919;\r\n    font-weight: 700;\r\n    margin: 0px;\r\n    margin-bottom: 26px;\r\n}\r\n\r\n\r\n.twofa-checkbox-container .checkmark {\r\n    height: 29px;\r\n    width: 29px;\r\n}\r\n\r\n.twofa-checkbox-container .checkmark:after {\r\n    left: 11px;\r\n    top: 6px;\r\n    width: 7px;\r\n    height: 14px;\r\n}\r\n\r\n.twofa-scan-term-checkbox {\r\n    display: flex;\r\n    gap: 42px;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.twofa-scan-term-checkbox p{\r\n    margin-top: -4px;\r\n}\r\n\r\n.twofa-head-main-wrap img:hover{\r\n    transform: scale(0.9);\r\n}\r\n\r\n\r\n.checkbox-container input {\r\n    position: absolute;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n    height: 0;\r\n    width: 0;\r\n}\r\n\r\n.checkbox-container .checkmark {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 30px;\r\n    width: 30px;\r\n    background-color: #f3f3f3;\r\n    border-radius: 0px;\r\n    border: none;\r\n}\r\n\r\n\r\n/******* Resposive css ****/\r\n@media (max-width: 768px) {\r\n    .signup-step-header-wrap {\r\n        width: 100%;\r\n        height: 80px;\r\n        margin-top: 28px;\r\n        padding: 0px 27px;\r\n    }\r\n\r\n    .profile-twofa-main-wrapper {\r\n        width: 100%;\r\n        padding: 0px 20px;\r\n    }\r\n\r\n    .twofa-progress-bar {\r\n        margin-top: 8px;\r\n    }\r\n\r\n    .step p {\r\n        font-size: 10px;\r\n        top: -20px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .step .dot {\r\n        width: 14px;\r\n        height: 14px;\r\n    }\r\n\r\n    .twofa-progress-bar::before {\r\n        top: 40px;\r\n    }\r\n\r\n    .twofa-head-main-wrap {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 18px;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .twofa-head-main-wrap img {\r\n        width: 33px;\r\n        height: 33px;\r\n        position: unset;\r\n    }\r\n\r\n    .twofa-head-main-wrap h3 {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .authenticator-image-wrap img {\r\n        width: 162px;\r\n        height: 162px;\r\n    }\r\n\r\n    .authenticator-image-wrap {\r\n        margin-top: 18px;\r\n        margin-bottom: 18px;\r\n    }\r\n\r\n    .profile-twofa-main-wrap {\r\n        width: 100%;\r\n        margin-left: 0px;\r\n        /* padding-bottom: 70px; */\r\n    }\r\n\r\n    .twofa-footer-wrap p {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .twofa-footer-wrapper {\r\n        width: 100%;\r\n        position: unset;\r\n        left: 0;\r\n        bottom: 80px;\r\n        right: 0;\r\n        padding: 30px 20px;\r\n        padding-top: 40px;\r\n    }\r\n\r\n    .authenticator-store-wrap p {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .authenticator-store-icons-wrap img {\r\n        width: 46px;\r\n        height: 46px;\r\n    }\r\n\r\n    .twofa-inner-wrapper {\r\n        height: unset;\r\n        /* height: calc(100vh - 540px); */\r\n    }\r\n\r\n    .twfa-scan-text p {\r\n        font-size: 14px;\r\n        padding-top: 10px;\r\n        margin-left: 50px;\r\n    }\r\n\r\n    .scaner-image-wrap {\r\n        width: 120px;\r\n        height: 120px;\r\n        margin-top: 20px;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .secert-key-wrap {\r\n        height: 62px;\r\n        padding: 0px 30px;\r\n    }\r\n\r\n    .secert-key-wrap img {\r\n        width: 18px;\r\n        height: 18px;\r\n    }\r\n\r\n    .twofa-checkbox-container .checkmark {\r\n        height: 25px;\r\n        width: 25px;\r\n    }\r\n\r\n    .twofa-checkbox-container .checkmark:after {\r\n        left: 10px;\r\n        top: 5px;\r\n        width: 6px;\r\n        height: 12px;\r\n    }\r\n\r\n    .twofa-scan-term-checkbox {\r\n        gap: 38px;\r\n    }\r\n\r\n    .authentication-code-main-wrap {\r\n        margin-top: 80px;\r\n        margin-bottom: 80px;\r\n        text-align: center;\r\n    }\r\n\r\n    .pin-code.password-otp-input input {\r\n        width: 100%;\r\n        height: 50px;\r\n        margin-right: 6px !important;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .enable-pin-code-input.pin-code.password-otp-input input{\r\n        width: 58px;\r\n        height: 58px;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .authentication-code-main-wrap p {\r\n        font-size: 14px;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .twofa-footer-wrap button {\r\n        height: 62px;\r\n        font-size: 14px;\r\n    }\r\n\r\n}\r\n\r\n\r\n@media (max-width: 360px) {\r\n \r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n    .signup-step-header-wrap {\r\n        width: 532px;\r\n        height: 82px;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .twofa-progress-bar {\r\n        margin-top: 8px;\r\n    }\r\n\r\n    .step p {\r\n        font-size: 12px;\r\n        top: -20px;\r\n    }\r\n\r\n    .step .dot {\r\n        width: 14px;\r\n        height: 14px;\r\n    }\r\n\r\n    .twofa-progress-bar::before {\r\n        top: 40px;\r\n    }\r\n\r\n    .twofa-head-main-wrap img {\r\n        width: 33px;\r\n        height: 33px;\r\n    }\r\n\r\n    .twofa-head-main-wrap h3 {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .authenticator-image-wrap img {\r\n        width: 135px;\r\n        height: 135px;\r\n    }\r\n\r\n    .authenticator-image-wrap {\r\n        margin-top: 26px;\r\n        margin-bottom: 26px;\r\n    }\r\n\r\n    .profile-twofa-main-wrap {\r\n        width: 348px;\r\n        margin-left: 120px;\r\n    }\r\n\r\n    .profile-twofa-main-wrapper {\r\n        width: 532px;\r\n    }\r\n\r\n    .twofa-footer-wrap p {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .twofa-footer-wrapper {\r\n        width: 348px;\r\n        position: unset;\r\n        padding-bottom: 100px;\r\n    }\r\n\r\n    .authenticator-store-wrap p {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .authenticator-store-icons-wrap img {\r\n        width: 47px;\r\n        height: 47px;\r\n    }\r\n\r\n    .twofa-inner-wrapper {\r\n        height: calc(100vh - 300px);\r\n    }\r\n\r\n    .twfa-scan-text p {\r\n        font-size: 12px;\r\n        padding-top: 8px;\r\n    }\r\n\r\n    .scaner-image-wrap {\r\n        width: 119px;\r\n        height: 120px;\r\n        margin-top: 26px;\r\n        margin-bottom: 34px;\r\n    }\r\n\r\n    .secert-key-wrap {\r\n        height: 48px;\r\n        padding: 0px 30px;\r\n    }\r\n\r\n    .secert-key-wrap img {\r\n        width: 18px;\r\n        height: 18px;\r\n    }\r\n\r\n    .twofa-checkbox-container .checkmark {\r\n        height: 25px;\r\n        width: 25px;\r\n    }\r\n\r\n    .twofa-checkbox-container .checkmark:after {\r\n        left: 10px;\r\n        top: 5px;\r\n        width: 6px;\r\n        height: 12px;\r\n    }\r\n\r\n    .twofa-scan-term-checkbox {\r\n        gap: 38px;\r\n    }\r\n\r\n    .authentication-code-main-wrap {\r\n        margin-top: 104px;\r\n        text-align: center;\r\n    }\r\n\r\n    .pin-code.password-otp-input input {\r\n        width: 50px;\r\n        height: 50px;\r\n        margin-right: 9px;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .enable-pin-code-input.pin-code.password-otp-input input{\r\n        width: 58px;\r\n        height: 58px;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .authentication-code-main-wrap p {\r\n        font-size: 14px;\r\n        margin-bottom: 20px;\r\n    }\r\n}\r\n\r\n\r\n@media (min-width: 1025px) and (max-width: 1599px) {\r\n    .signup-step-header-wrap {\r\n        width: 532px;\r\n        height: 82px;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .twofa-progress-bar {\r\n        margin-top: 8px;\r\n    }\r\n\r\n    .step p {\r\n        font-size: 12px;\r\n        top: -20px;\r\n    }\r\n\r\n    .step .dot {\r\n        width: 14px;\r\n        height: 14px;\r\n    }\r\n\r\n    .twofa-progress-bar::before {\r\n        top: 40px;\r\n    }\r\n\r\n    .twofa-head-main-wrap img {\r\n        width: 33px;\r\n        height: 33px;\r\n    }\r\n\r\n    .twofa-head-main-wrap h3 {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .authenticator-image-wrap img {\r\n        width: 135px;\r\n        height: 135px;\r\n    }\r\n\r\n    .authenticator-image-wrap {\r\n        margin-top: 26px;\r\n        margin-bottom: 26px;\r\n    }\r\n\r\n    .profile-twofa-main-wrap {\r\n        width: 348px;\r\n        margin-left: 120px;\r\n    }\r\n\r\n    .profile-twofa-main-wrapper {\r\n        width: 532px;\r\n    }\r\n\r\n    .twofa-footer-wrap p {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .twofa-footer-wrapper {\r\n        width: 348px;\r\n        padding-bottom: 30px;\r\n        left: 60px;\r\n    }\r\n\r\n    .authenticator-store-wrap p {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .authenticator-store-icons-wrap img {\r\n        width: 47px;\r\n        height: 47px;\r\n    }\r\n\r\n    .twofa-inner-wrapper {\r\n        height: calc(100vh - 300px);\r\n    }\r\n\r\n    .twfa-scan-text p {\r\n        font-size: 12px;\r\n        padding-top: 8px;\r\n    }\r\n\r\n    .scaner-image-wrap {\r\n        width: 119px;\r\n        height: 120px;\r\n        margin-top: 26px;\r\n        margin-bottom: 34px;\r\n    }\r\n\r\n    .secert-key-wrap {\r\n        height: 48px;\r\n        padding: 0px 30px;\r\n    }\r\n\r\n    .secert-key-wrap img {\r\n        width: 18px;\r\n        height: 18px;\r\n    }\r\n\r\n    .twofa-checkbox-container .checkmark {\r\n        height: 25px;\r\n        width: 25px;\r\n    }\r\n\r\n    .twofa-checkbox-container .checkmark:after {\r\n        left: 10px;\r\n        top: 5px;\r\n        width: 6px;\r\n        height: 12px;\r\n    }\r\n\r\n    .twofa-scan-term-checkbox {\r\n        gap: 38px;\r\n    }\r\n\r\n    .authentication-code-main-wrap {\r\n        margin-top: 104px;\r\n        text-align: center;\r\n    }\r\n\r\n    .pin-code.password-otp-input input {\r\n        width: 50px;\r\n        height: 50px;\r\n        margin-right: 9px;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .enable-pin-code-input.pin-code.password-otp-input input{\r\n        width: 58px;\r\n        height: 58px;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .authentication-code-main-wrap p {\r\n        font-size: 14px;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
